var _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgChevronLeftDouble(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M22.6691 0.819495C23.321 1.4714 23.321 2.52835 22.6691 3.18025L14.0301 11.8193L22.6691 20.4584C23.321 21.1103 23.321 22.1672 22.6691 22.8191C22.0172 23.4711 20.9603 23.4711 20.3084 22.8191L10.4889 12.9997C9.83703 12.3478 9.83703 11.2908 10.4889 10.6389L20.3084 0.819495C20.9603 0.16759 22.0172 0.16759 22.6691 0.819495Z",
    fill: "#333333"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M13.0902 0.819495C13.7421 1.4714 13.7421 2.52835 13.0902 3.18025L4.45108 11.8193L13.0902 20.4584C13.7421 21.1103 13.7421 22.1672 13.0902 22.8191C12.4382 23.4711 11.3813 23.4711 10.7294 22.8191L0.909949 12.9997C0.258044 12.3478 0.258045 11.2908 0.909949 10.6389L10.7294 0.819495C11.3813 0.16759 12.4382 0.16759 13.0902 0.819495Z",
    fill: "#333333"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgChevronLeftDouble);
export default __webpack_public_path__ + "static/media/chevron-left-double.5fcfcf0c0af3c76d340660a48d26b4dd.svg";
export { ForwardRef as ReactComponent };